module.exports = __webpack_public_path__ + "img/bulgaria.c519545.webp";